var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('el-dialog', {
    attrs: {
      "title": "Preview",
      "visible": _vm.visible,
      "width": "1020px",
      "top": "3vh",
      "custom-class": "preview-dialog"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.visible = $event;
      }
    }
  }, [_c('div', {
    staticClass: "pb20 preview-wrapper"
  }, [_vm.visible && _vm.id ? _c('iframe', {
    ref: "previewIframe",
    staticClass: "preview-iframe",
    attrs: {
      "src": _vm.iframeSrc,
      "frameborder": "0"
    }
  }) : _vm._e()])]);
}
var staticRenderFns = []

export { render, staticRenderFns }